import { memo } from 'react';
import { useTranslation } from 'react-i18next';
import { type LearnerProject } from 'LearnerProjects';
import { ProjectDirectLinkBox } from 'ProjectContentBox';
import { SidebarBoxKey } from 'AdmissionsGuidance';
import { BasicDesktopBox } from '../../BasicDesktopBox';
import { usePastDueCoursesAndProjects } from '../StatusBox/usePastDueCoursesAndProjects';

function LateProjectSubmissionBoxComponent() {
    const { allPastDueProjects } = usePastDueCoursesAndProjects();
    return <LateProjectSubmissionBoxPresentation pastDueProjects={allPastDueProjects} />;
}

function LateProjectSubmissionBoxPresentation({ pastDueProjects }: { pastDueProjects: LearnerProject[] }) {
    const { t } = useTranslation('back_royal', { keyPrefix: 'lateProjectSubmissionBox' });
    const plural = (pastDueProjects.length ?? 0) > 1;

    return (
        <BasicDesktopBox
            boxKey={SidebarBoxKey.late_project_submission}
            headerText={t(plural ? 'heading_plural' : 'heading')}
        >
            {t(plural ? 'content_plural' : 'content')}

            <div className="mt-2.5">
                {pastDueProjects.map(project => (
                    <div key={project.id} className="mb-2.5">
                        <ProjectDirectLinkBox project={project} fullWidth padding="2.5" titleSize="sm" />
                    </div>
                ))}
            </div>
        </BasicDesktopBox>
    );
}

export const LateProjectSubmissionBox = memo(
    LateProjectSubmissionBoxComponent,
) as unknown as typeof LateProjectSubmissionBoxComponent;
